import UsersPage from '@/views/profile/UsersPage'

export default function UsersScreen() {
  return <UsersPage />
}
